<template>
  <div>
    <div class="team-score" v-if="match">
      <div class="score-box-left" >
        <strong class="player-name" v-if="match.activeBatsman1 && match.activeBatsman1.player && match.activeBatsman1.player.name">{{match.activeBatsman1.player.name}}  <i class="ico-bat ml-5" v-if="match.activeBatsman1.active"></i></strong>
        <span class="bat-score" v-if="match.activeBatsman1">{{match.activeBatsman1.score}} ({{match.activeBatsman1.balls}})</span>
      </div>
      <div class="score-box-right">
        <strong class="player-name" v-if="match.activeBatsman2 && match.activeBatsman2.player && match.activeBatsman2.player.name"><i class="ico-bat mr-5" v-if="match.activeBatsman2.active"></i> {{match.activeBatsman2.player.name}}</strong>
        <span class="bat-score" v-if="match.activeBatsman2">{{match.activeBatsman2.score}} ({{match.activeBatsman2.balls}})</span>
      </div>
    </div>
      <div class="scored_commentary_tabs_outer" v-if="match">
          <div class="one_match_details" >
              <div v-if="match.status!='Not Started'" :class="(match.old_widget == 0) ? 'clc_widget_crctGround_dtl animation-live' : 'clc_widget_dtl_picth finish-status'">
                <div id="cricket-widget">
                  <div class="circket_wrapper">
                    <div class="live_ground_content" >
                      <div class="main_ground_img">
                          <div class="players-wrpa" >
                              <div id="wagon">
                                  <div class="App">
                                      <div class="balltrack" id="ball_track">
                                        <img :src="require('@/assets/images/widget/images/ball.png')" id="ball" style="display: none;" />
                                        <img :src="require('@/assets/images/widget/images/ball_shadow.png')" id="ball_shadowUrl" style="display: none;" />
                                        <div class="main_box" :style="{ backgroundImage: 'url(' + require('@/assets/images/widget/images/pitch.png') + ')' }">
                                          <div :class="match.batsman_left_flag" v-if="match.activeInning.team_id && !match.is_test_match">
                                            <img :src="`https://bw.sixlogics.com/cricket/assets/images/team_kits_new/${match.activeInning.team_id}_batsman.png`" />
                                            </div>
                                          <div :class="match.batsman_left_flag" v-else>
                                            <img :src="require('@/assets/images/default_player.png')" alt="bat" />
                                          </div>
                                          <canvas id="canvas" ref="canvas_ball_track" width="507" height="703" style="width: 100%;"></canvas>
                                        </div>
                                      </div>
                                      <div class="wagon">
                                        <ul class="wagon-info-list">
                                            <li v-if="match.activeInning.overs">Over {{parseFloat(match.activeInning.overs).toFixed(1)}}</li>
                                            <li v-if="match.latest_commentaries && match.latest_commentaries!=''"> {{match.latest_commentaries[0].score}}</li>
                                            <li v-if="match.latest_commentaries && match.latest_commentaries!='' && match.latest_commentaries[0].position!='0' && typeof match.activeBatsman1.player!=='undefined' && match.activeBatsman1.player.batting_style=='Right-hand bat' && short_type(match.latest_commentaries[0].position)"> {{short_type(match.latest_commentaries[0].position)}}</li>
                                            <li v-if="match.latest_commentaries && match.latest_commentaries!='' && match.latest_commentaries[0].position!='0' && typeof match.activeBatsman1.player!=='undefined' && match.activeBatsman1.player.batting_style=='Left-hand bat' && left_short_type(match.latest_commentaries[0].position)"> {{left_short_type(match.latest_commentaries[0].position)}}</li>
                                        </ul>
                                        <div class="wagon_wheel_wrap">
                                          <div class="wagon_wheel_left">
                                            <canvas id="latest_comment_wagonwheel" ref="latest_comment_wagonwheel_ref" style="border-radius: inherit;"></canvas>
                                          </div>
                                        </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                      <div>
                      </div>
                  </div>
              </div>
            </div>
            <img style="display: none;" src="@/assets/images/widget/images/new_ground.png?v=2" />
         </div>
        </div>
    </div>
    <div class="team-score">
      <div class="score-box-left" v-if="match && match.activeBowler">
        <strong class="player-name" v-if="match.activeBowler && match.activeBowler.player">{{match.activeBowler.player.name}}</strong>
        <span class="over" v-if="match.activeBowler && match.activeBowler.overs">Ov:<strong>{{match.activeBowler.overs}}</strong>  - R: <strong v-if="match.activeBowler.score">{{match.activeBowler.score}}</strong> - W: <strong v-if="match.activeBowler.wickets">{{match.activeBowler.wickets}}</strong></span>
      </div>
    </div>
    <ul class="last-over" v-if="match && match.activeBowler">
      <li style="cursor: pointer;" v-for="matchOver in Object.keys(match.currentOver).sort((a, b) => b - a)" :key="matchOver" :class="match.currentOver[matchOver].d_score == 'w' || match.currentOver[matchOver].d_score == 'W' ? 'wicket' : match.currentOver[matchOver].d_score =='6' ? 'six':match.currentOver[matchOver].d_score =='4' ? 'four':match.currentOver[matchOver].d_score =='nb' ? 'no-ball radius-10': (match.currentOver[matchOver].d_score =='wd1' || match.currentOver[matchOver].d_score =='wd') ? 'wide' : match.currentOver[matchOver].d_score =='nb+lb' ? 'no-ball-run radius-10': 'no-class' " v-on:click="ballAnimation(match.currentOver[matchOver].id,match.currentOver[matchOver].over)">
         <span> {{ match.currentOver[matchOver].d_score }}</span>
      </li>
      <!-- {{ match.currentOver }} -->
    </ul>
  </div>
  </template>

  <script type="text/javascript">
      import Vue from 'vue';
      export default {
          name: "cricket-widget",
          data() {
              return {
                  match: null,
                  canvas: null,
                  countfirst: 1,
                  popup_value:'',
                  new_ball_position: '',
                  left: {
                      "days": '',
                      "hours": '',
                      "minutes": '',
                      "seconds": ''
                  },
                  pre_commentry_id: 0,
                  ctx: "",
              }
          },
       async mounted () {
               var _this=this;
             await  this.getDetail();
                setTimeout(() => {
                    this.getDetail();
                }, 500);
                window.matchDetailIntv = setInterval(() => {
                    this.getDetail();
                }, 60000);
                this.$root.$on('MatchUpdated', data => {
                    if (data.match_id == this.match.id)
                    {
                        _this.getDetail();
                    }
                });

          },
          beforeDestroy() {
              clearInterval(window.matchDetailIntv);
          },
          serverPrefetch() {
              return this.getDetail();
          },
          methods: {
              BowerImageUrl(event)
              {
                  event.target.src = "https://bw.sixlogics.com/cricket/assets/images/team_kits/Bowler.png"
              },
              BatsmanImageUrl(event)
              {
                  event.target.src = "https://bw.sixlogics.com/cricket/assets/images/team_kits/Batsman.png"
              },
              async getDetail()
              {

                  await this.$axios
                          .get(this.$MATCH_COMMENTRY_API.replace(':match', this.$route.params.match))
                          .then(response => {
                              this.match = response.data.result;
                              this.match.currentOver_c = [];
                              this.match.currentOver_d_s = [];
                              if (this.countfirst !== 1 && this.match.latest_commentaries && this.match.latest_commentaries.length > 0)
                              {
                                  let latest_commentaries = this.match.latest_commentaries;
                                  let cur_commentry_id = '';
                                  if (this.match.latest_commentaries[0].ball_postions && this.match.latest_commentaries[0].ball_postions.length == '3')
                                  {
                                      let postion1 = this.match.latest_commentaries[0].ball_postions[0].split('_');
                                      let postion2 = this.match.latest_commentaries[0].ball_postions[1].split('_');
                                      let postion3 = this.match.latest_commentaries[0].ball_postions[2].split('_');
                                      var self = this;
                                      if (typeof latest_commentaries[0].id !== 'undefined')
                                      {
                                          cur_commentry_id = latest_commentaries[0].id;
                                      }
                                      if (this.pre_commentry_id == 0)
                                      {
                                          this.popup_value='';
                                          this.pre_commentry_id = cur_commentry_id;
                                          var duration = 1;
                                          this.wagon_wheel(latest_commentaries, 'latest_comment_wagonwheel', true);
                                          setTimeout(function () {
                                              self.ballTrackFunction(postion1[0], postion1[1], postion2[0], postion2[1], postion3[0], postion3[1], duration);
                                          }, 1)
                                      } else if (cur_commentry_id != this.pre_commentry_id)
                                      {
                                          this.pre_commentry_id = cur_commentry_id;
                                          this.wagon_wheel(latest_commentaries, 'latest_comment_wagonwheel', true);
                                          var duration = 1500;
                                          setTimeout(function () {
                                              self.ballTrackFunction(postion1[0], postion1[1], postion2[0], postion2[1], postion3[0], postion3[1], duration);
                                          }, 1000)
                                          if(this.popup_value!='')
                                          {
                                             setTimeout(function () {
                                                this.popup_value='';
                                               }, 3000)
                                          }
                                      }
                                      else
                                      {
                                                this.popup_value='';
                                      }
                                  }
                                else
                                {
                                  if (typeof latest_commentaries[0].id !== 'undefined')
                                      {
                                          cur_commentry_id = latest_commentaries[0].id;
                                      }
                                       if (this.pre_commentry_id == 0)
                                      {
                                          this.popup_value='';
                                          this.pre_commentry_id = cur_commentry_id;
                                      }
                                       else if (cur_commentry_id != this.pre_commentry_id)
                                      {
                                         this.pre_commentry_id = cur_commentry_id;
                                          if(this.popup_value!='')
                                          {
                                             setTimeout(function () {
                                                this.popup_value='';
                                               }, 3000)
                                          }
                                      }
                                      else
                                      {
                                         this.popup_value='';
                                      }
                                }
                              }
                              if(this.match.status=='Finished'){
                                 this.popup_value='';
                              }
                            if (this.countfirst == 1) {
                                this.popup_value='';
                                this.countfirst++;
                            }

                          })
                          .catch(error => console.log(error));
              },
              async ballAnimation(commentaryId,overBall){
                await this.$axios
                          .get(this.$MATCH_POINT_API.replace(':match', this.$route.params.match),{params: {id: commentaryId,over:overBall}})
                          .then(response => {
                          let points=response.data.result.ball_points;
                          if (points && points.length == '3')
                          {
                              let postion1 = points[0].split('_');
                              let postion2 = points[1].split('_');
                              let postion3 = points[2].split('_');
                              var duration = 1500;
                              this.ballTrackFunction(postion1[0], postion1[1], postion2[0], postion2[1], postion3[0], postion3[1], duration);
                          }

                          })
                          .catch(error => console.log(error));
              },
              wagon_wheel(latest_commentaries, id = "latest_comment_wagonwheel", single_ball = null) {

                  var canvas = document.getElementById(id);
                  if (typeof canvas !== 'undefined' && canvas !== null) {
                      var ctx = canvas.getContext('2d');
                      //ctx.clearRect(0, 0, canvas.width, canvas.height);
                      single_ball = single_ball || false;
                      if (latest_commentaries.length > 0 && latest_commentaries[0].position > 0) {
                          canvas = document.getElementById(id);
                          canvas.width = canvas.parentElement.clientWidth;
                          canvas.height = canvas.parentElement.clientHeight;
                          if (canvas.getContext) {
                              var startingPoint = {
                                  xAxis: canvas.width / 2,
                                  yAxis: canvas.height / 2 - 10,
                              };
                              ctx = canvas.getContext('2d');
                              ctx.clearRect(0, 0, canvas.width, canvas.height);
                              var colors = {
                                  1: '#bd08f3',
                                  2: '#ffff00',
                                  3: '#ffff00',
                                  4: '#ebebeb',
                                  6: '#ed2e12'
                              };
                              var lengths = {
                                  1: canvas.width / 5,
                                  2: canvas.width / 3,
                                  3: canvas.width / 2.66,
                                  4: canvas.width / 2.35,
                                  6: canvas.width / 2.1
                              };
                              for (var i = 0; i < latest_commentaries.length; i++) {
                                  var color = '#ffff00';
                                  if (colors.hasOwnProperty(latest_commentaries[i].sc)) {
                                      color = colors[latest_commentaries[i].sc];
                                  }
                                  var len = 40;
                                  if (lengths.hasOwnProperty(latest_commentaries[i].sc)) {
                                      len = lengths[latest_commentaries[i].sc];
                                  }

                                  if (id == "latest_comment_wagonwheel") {

                                      if (lengths.hasOwnProperty(latest_commentaries[i].sc)) {
                                         len = lengths[latest_commentaries[i].sc];
                                      } else {
                                          len = lengths['0'];
                                      }
                                  }
                                  var angle = latest_commentaries[i].position;
                                  var x = Math.cos(angle * Math.PI / 180) * len;
                                  var y = Math.sin(angle * Math.PI / 180) * len;
                                  var targetPoint = {
                                      xAxis: startingPoint.xAxis + x,
                                      yAxis: startingPoint.yAxis + 10 + y,
                                  };
                                  ctx.beginPath();
                                  ctx.moveTo(startingPoint.xAxis, startingPoint.yAxis);
                                  ctx.lineWidth = 1.5;
                                  ctx.lineTo(targetPoint.xAxis, targetPoint.yAxis);
                                  ctx.strokeStyle = color;
                                  ctx.stroke();

                                  if (single_ball) {
                                      ctx.beginPath();
                                      ctx.arc(targetPoint.xAxis, targetPoint.yAxis, 3, 0, 2 * Math.PI, false);
                                      ctx.fillStyle = 'red';
                                      ctx.fill();
                                      ctx.strokeStyle = 'red';
                                      ctx.stroke();
                                  }

                                  ctx.closePath();
                              }
                          }
                      }
              }
              },
              ballTrackFunction(x1, y1, x2, y2, x3, y3, duration)
              {
                  // var ctx = this.ctx;
                  this.canvas = this.$refs.canvas_ball_track;
                  var ctx = this.canvas.getContext('2d')
                  ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
                  // console.log('sd',this.$refs.canvas_ball_track,this.canvas.width);
                  var canvasWidth = this.canvas.width;
                  var canvasHeight = this.canvas.height;
                  var mid = (x2);
                  var csX = mid / 2;
                  var csY = y2 * 0.9;
                  if (x2 == x1 && x1 > 50)
                  {
                      csX = mid * 1.5;
                  } else if (x2 == x1 && x1 < 50)
                  {
                      csX = mid / 2;
                  } else if (x2 > x1 && x1 < 50)
                  {
                      csX = mid * 0.7;
                  } else if (x1 > 50)
                  {
                      csX = mid * 1.2;
                  } else if (x1 < 50)
                  {
                      csX = mid / 2;
                  } else
                  {
                      csX = mid;
                  }
                  var p1x = (x1 * canvasWidth) / 100;
                  var p1y = (y1 * canvasHeight) / 100;
                  var p2x = (x2 * canvasWidth) / 100;
                  var p2y = (y2 * canvasHeight) / 100;
                  var p3x = (x3 * canvasWidth) / 100;
                  var p3y = (y3 * canvasHeight) / 100;
                  var curveSplitX = (csX * canvasWidth) / 100;
                  var curveSplitY = (csY * canvasHeight) / 100;
                  localStorage.setItem('p1x', p1x);
                  localStorage.setItem('p1y', p1y);
                  localStorage.setItem('p2x', p2x);
                  localStorage.setItem('p2y', p2y);
                  localStorage.setItem('p3x', p3x);
                  localStorage.setItem('p3y', p3y);
                  localStorage.setItem('curveSplitX', curveSplitX);
                  localStorage.setItem('curveSplitY', curveSplitY);
                  this.animatePathDrawing(ctx, p1x, p1y, curveSplitX, curveSplitY, p2x, p2y, p3x, p3y, duration);
              },
              animatePathDrawing(ctx, x0, y0, x1, y1, x2, y2, x3, y3, duration)
              {
                  var start = null;
                  var _this = this;
                  var step = function animatePathDrawingStep(timestamp) {
                      if (start === null)
                          start = timestamp;
                      var delta = timestamp - start,
                              progress = Math.min(delta / duration, 1);
                      // Clear canvas
                      ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
                      var background = new Image();
                      ctx.drawImage(background, 0, 0);
                      // Draw curve
                      let t0 = 0;
                      _this.drawBezierSplit(ctx, x0, y0, x1, y1, x2, y2, x3, y3, t0, progress);
                      if (progress < 1)
                      {
                          window.requestAnimationFrame(step);
                      }
                  };
                  window.requestAnimationFrame(step);
              },

              drawBezierSplit(ctx, x0, y0, x1, y1, x2, y2, x3, y3, t0, t1) {
                  ctx.beginPath();
                  var _this = this;
                  ctx.lineWidth = 20;

                  if (t0 == 0.0 && t1 == 1.0)
                  {
                      ctx.moveTo(x0, y0);
                      ctx.quadraticCurveTo(x1, y1, x2, y2);
                      _this.animateLine(ctx, x2, y2, x3, y3, 0);
                  } else if (t0 != t1)
                  {
                      var t00 = t0 * t0,
                              t01 = 1.0 - t0,
                              t02 = t01 * t01,
                              t03 = 2.0 * t0 * t01;
                      var nx0 = t02 * x0 + t03 * x1 + t00 * x2,
                              ny0 = t02 * y0 + t03 * y1 + t00 * y2;
                      t00 = t1 * t1;
                      t01 = 1.0 - t1;
                      t02 = t01 * t01;
                      t03 = 2.0 * t1 * t01;
                      var nx2 = t02 * x0 + t03 * x1 + t00 * x2,
                              ny2 = t02 * y0 + t03 * y1 + t00 * y2;
                      var nx1 = lerp(lerp(x0, x1, t0), lerp(x1, x2, t0), t1),
                              ny1 = lerp(lerp(y0, y1, t0), lerp(y1, y2, t0), t1);
                      ctx.moveTo(nx0, ny0);
                      ctx.quadraticCurveTo(nx1, ny1, nx2, ny2);
                      if (x3 > 0) {
                          var grad = ctx.createLinearGradient(x1, y1, x3, y3);
                          grad.addColorStop(0, "rgba(255,255,255,0.3)");
                          grad.addColorStop(0.3, "rgba(50, 100, 188,1)");
                          grad.addColorStop(1, "rgba(50, 100, 188,1)");
                          ctx.strokeStyle = grad;
                          ctx.stroke();
                      } else {
                          var grad = ctx.createLinearGradient(x1, y1, x2, y2);
                          grad.addColorStop(0, "rgba(255,255,255,0.4)");
                          grad.addColorStop(1, "rgba(50, 100, 188,1)");
                          ctx.strokeStyle = grad;
                          ctx.stroke();
                          ctx.shadowBlur = 5;
                          ctx.shadowColor = "black";
                      }
                      ctx.drawImage(document.getElementById('ball_shadowUrl'), nx2 - 12, ny2 - 12, 24, 24);
                  }
                  ctx.closePath();
              },
              animateLine(ctx, x, y, xf, yf, ratio) {
                  ratio = ratio || 0;
                  var _this = this;
                  this.drawLine(ctx, x, y, xf, yf, ratio);
                  if (ratio < 1) {
                      requestAnimationFrame(function () {
                          _this.animateLine(ctx, x, y, xf, yf, ratio + 0.1);
                      });
                  }
              },
              drawLine(ctx, x1, y1, x2, y2, ratio) {

                  ctx.beginPath();
                  ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
                  x2 = x1 + ratio * (x2 - x1);
                  y2 = y1 + ratio * (y2 - y1);
                  ctx.moveTo(localStorage.getItem('p1x'), localStorage.getItem('p1y'));
                  ctx.quadraticCurveTo(localStorage.getItem('curveSplitX'), localStorage.getItem('curveSplitY'), localStorage.getItem('p2x'), localStorage.getItem('p2y'));
                  ctx.moveTo(x1, y1);
                  ctx.lineTo(x2, y2);
                  if (localStorage.getItem('p3x') > 0) {
                      var grad = ctx.createLinearGradient(localStorage.getItem('p1x'), localStorage.getItem('p1y'), localStorage.getItem('p3x'), localStorage.getItem('p3y'));
                      grad.addColorStop(0, "rgba(255,255,255,0.3)");
                      grad.addColorStop(1, "rgba(50, 100, 188,1)");
                  } else {
                      var grad = ctx.createLinearGradient(localStorage.getItem('p1x'), localStorage.getItem('p1y'), localStorage.getItem('p2x'), localStorage.getItem('p2y'));
                      grad.addColorStop(0, "rgba(255,255,255,0.3)");
                      grad.addColorStop(1, "rgba(50, 100, 188,1)");
                  }
                  ctx.lineWidth = 16;
                  ctx.strokeStyle = grad;
                  ctx.stroke();
                  ctx.closePath();
                  ctx.drawImage(document.getElementById('ball'), x2 - 12, y2 - 10, 20, 20);
                  let diff = (200 - x2) * 3;
                  if (localStorage.getItem('p3x') > 50) {
                      diff = ((ctx.canvas.width / 2) - x2) * 2;
                      diff = ((x2) + diff);
                  } else {
                      diff = ((ctx.canvas.width / 2) - x2) * 2;
                      diff = ((x2) + diff);
                  }
                  ctx.beginPath();
                  ctx.lineWidth = 16;
                  ctx.moveTo(localStorage.getItem('p2x'), localStorage.getItem('p2y'));
                  let y2_mid = y2 * 2 < 184 ? 183 : y2 * 2;
                  ctx.lineTo(diff, y2_mid);
                  ctx.strokeStyle = 'rgba(0, 0, 0,0.1)';
                  ctx.stroke();
                  ctx.closePath();
                  ctx.beginPath();
                  ctx.lineWidth = 16;
                  ctx.moveTo(localStorage.getItem('p2x'), localStorage.getItem('p2y'));
                  ctx.lineTo(x2, y2);
                  ctx.strokeStyle = 'rgba(50, 100, 188,0.7)';
                  ctx.stroke();
                  ctx.drawImage(document.getElementById('ball'), x2 - 12, y2 - 10, 20, 20);
                  ctx.closePath();
                  var initial_x = localStorage.getItem('p1x') * 2;
                  if (localStorage.getItem('p1x') < (ctx.canvas.width / 2)) {
                      var initial_x = localStorage.getItem('p1x') * 2;
                  } else {
                      var initial_x = localStorage.getItem('p1x') * 0.7;
                  }
                  ctx.beginPath();
                  ctx.lineWidth = 16;
                  ctx.moveTo(localStorage.getItem('p2x'), localStorage.getItem('p2y'));
                  ctx.lineTo(initial_x, localStorage.getItem('p1y'));
                  ctx.strokeStyle = 'rgba(0, 0, 0,0.1)';
                  ctx.stroke();
                  ctx.closePath();
                  if (localStorage.getItem('p2y') > 319) {
                      ctx.drawImage(document.getElementById('ball_shadowUrl'), localStorage.getItem('p2x') - 20, localStorage.getItem('p2y') - 15, 30, 30);
                  } else {
                      ctx.drawImage(document.getElementById('ball_shadowUrl'), localStorage.getItem('p2x') - 20, localStorage.getItem('p2y') - 15, 30, 30);
                  }
              },
              short_type(postion)
              {
                  if (postion == 257 || postion == 249 || postion == 241)
                  {
                      return 'late cut';
                  } else if (postion == 193 || postion == 201 || postion == 209 || postion == 217 || postion == 225 || postion == 233)
                  {
                      return 'cut';
                  } else if (postion == 185 || postion == 177)
                  {
                      return 'square cut';
                  } else if (postion == 169 || postion == 161)
                  {
                      return 'square drive';
                  } else if (postion == 73 || postion == 81 || postion == 89)
                  {
                      return 'straight drive';
                  } else if (postion == 153 || postion == 145 || postion == 137 || postion == 129)
                  {
                      return 'cover drive';
                  } else if (postion == 57 || postion == 49 || postion == 41 || postion == 65)
                  {
                      return 'on drive';
                  } else if (postion == 121 || postion == 113 || postion == 105 || postion == 97)
                  {
                      return 'off drive';
                  } else if (postion == 1 || postion == 9 || postion == 17 || postion == 25 || postion == 33)
                  {
                      return 'pull';
                  } else if (postion == 313 || postion == 321 || postion == 329 || postion == 337 || postion == 145 || postion == 253)
                  {
                      return 'hook';
                  } else if (postion == 249 || postion == 241 || postion == 233)
                  {
                      return 'leg glance left';
                  } else
                  {
                      return '';
                  }
              },
              left_short_type(postion)
              {
                  if (postion == 297 || postion == 281 || postion == 289)
                  {
                      return 'late cut';
                  } else if (postion == 345 || postion == 337 || postion == 329 || postion == 321 || postion == 313 || postion == 305)
                  {
                      return 'cut';
                  } else if (postion == 353 || postion == 1)
                  {
                      return 'square cut';
                  } else if (postion == 17 || postion == 9)
                  {
                      return 'square drive';
                  } else if (postion == 49 || postion == 41 || postion == 33 || postion == 25)
                  {
                      return 'cover drive';
                  } else if (postion == 81 || postion == 73 || postion == 65 || postion == 57)
                  {
                      return 'off drive';
                  } else if (postion == 105 || postion == 97 || postion == 89)
                  {
                      return 'straight drive';
                  } else if (postion == 137 || postion == 129 || postion == 121 || postion == 113)
                  {
                      return 'on drive';
                  } else if (postion == 177 || postion == 169 || postion == 161 || postion == 153 || postion == 145)
                  {
                      return 'pull';
                  } else if (postion == 225 || postion == 217 || postion == 209 || postion == 201 || postion == 193 || postion == 185)
                  {
                      return 'hook';
                  } else if (postion == 249 || postion == 241 || postion == 233)
                  {
                      return 'leg glance';
                  } else
                  {
                      return '';
                  }
              }
          },
      }
      function lerp(v0, v1, t) {
          return (1.0 - t) * v0 + t * v1;
      }
  </script>
<style  lang="scss">
@import "../../assets/scss/components/cricket-widget.scss";

</style>

